<template>
  <div class="stepper">
    <template v-for="(s, i) in steps">
      <span :key="s.id" class="step-pill" :class="pillClass(i)">
        <span class="num">{{ i + 1 }}</span><span class="step-label">{{ s.label }}</span>
      </span>
      <span v-if="i < steps.length - 1" :key="s.id + '-sep'" class="step-sep"></span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'lp-stepper',
  props: {
    steps: { type: Array, required: true },
    activeId: { type: String, required: true },
  },
  computed: {
    activeIndex() {
      return this.steps.findIndex(s => s.id === this.activeId)
    },
  },
  methods: {
    pillClass(i) {
      if (i === this.activeIndex) return 'active'
      if (i < this.activeIndex) return 'done'
      return ''
    },
  },
}
</script>

<style lang="scss">
.stepper {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--fs-small);
  flex-wrap: wrap;
}
.step-pill {
  padding: 6px 12px;
  border-radius: var(--radius-md);
  font-size: var(--fs-label);
  color: var(--text-tertiary);
  display: flex;
  align-items: center;
  gap: 6px;
}
.step-pill .num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid var(--text-tertiary);
  font-size: var(--fs-caption);
  font-weight: 500;
}
.step-pill.active {
  background: var(--brand-soft);
  color: var(--brand-deep);
  font-weight: 500;
}
.step-pill.active .num {
  background: var(--brand);
  color: white;
  border-color: var(--brand);
}
.step-pill.done { color: var(--brand-deep); }
.step-pill.done .num {
  background: var(--brand-deep);
  color: white;
  border-color: var(--brand-deep);
}
.step-sep { width: 18px; height: 1.5px; background: var(--border-strong); border-radius: 1px; }

@media (max-width: 800px) {
  .step-pill { padding: 4px 8px; font-size: var(--fs-caption); }
  .step-sep { width: 8px; }
}

/* Phones: only the active step keeps its label, the rest collapse to the
   number. Visually hidden rather than removed so screen readers still get it. */
@media (max-width: 640px) {
  .step-pill:not(.active) { gap: 0; }
  .step-pill:not(.active) .step-label {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
}
</style>
